import textServices from 'services/text-services'

const HowToParticipate = () => {
  return (
    <section className="neighbars__how-to">
      <h2 className="neighbars__how-to-title">
        {textServices.findByText('neighbars/howTo/title', '¿Cómo participar?')}
      </h2>
      <div className="neighbars__how-to-grid">
        <article className="neighbars__how-to-card">
          <span className="neighbars__how-to-number">1</span>
          <h3 className="neighbars__how-to-card-title">
            {textServices.findByText('neighbars/howTo/step1/title', 'Registra tu comunidad')}
          </h3>
          <p className="neighbars__how-to-card-text">
            {textServices.findByText(
              'neighbars/howTo/step1/text',
              'Comparte tus datos y sube una foto del área común donde podría realizarse la Viewing Party.'
            )}
          </p>
        </article>
        <article className="neighbars__how-to-card">
          <span className="neighbars__how-to-number">2</span>
          <p className="neighbars__how-to-card-lead">
            {textServices.findByText(
              'neighbars/howTo/step2/text',
              <>
                <b>Cuéntanos</b> qué ha dificultado la conexión entre vecinos.
              </>
            )}
          </p>
        </article>
        <article className="neighbars__how-to-card neighbars__how-to-card--wide">
          <span className="neighbars__how-to-number">3</span>
          <p className="neighbars__how-to-card-lead">
            {textServices.findByText(
              'neighbars/howTo/step3/text',
              <>
                <b>Serás contactado por correo</b> para coordinar los siguientes pasos.
              </>
            )}
          </p>
        </article>
      </div>
    </section>
  )
}

export default HowToParticipate
